import { IApplicationState } from '../../../../../../types/types';
import { IFilter } from '../filter/types';

export const savedFilterSelector = (
    state: IApplicationState,
    filterId: number
): IFilter => {
    return state.filters.savedFilters[filterId]
};
